var utils = angular.module('msUtils', []);

/**
 * only-one-of-these model transform
 *
 * ng-model must be of type array.
 * only-one-of-these attribute must be an array too.
 *
 * example:
 * items = ["test", "a", "b", "c"]
 * <select ng-model="model.id" only-one-of-these="Object(items).keys()">
 *   <option ng-repeat="item in items" ng-value="item">item</option>
 * </select>
 */
utils.directive('onlyOneOfThese', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            if (!ngModel) return; // ngModel is required
            var selectable_keys = $parse(attr.onlyOneOfThese)(scope); // parse items

            // return the display_name: the selected key or null, instead of the original model (a list)
            ngModel.$formatters.push(function (value) {
                var result = null; // default
                if (!value || !angular.isArray(value)) {
                    return result;
                }
                selectable_keys.forEach(function (key) {
                    if (value.indexOf(key) >= 0) {
                        result = key;
                    }
                });
                return result;
            });

            // removes the old key from the model(a list) and appends the new value!
            ngModel.$parsers.push(function (value) {
                var out = []; // reset the model
                var values = ngModel.$$rawModelValue;
                if (!values) values = [];
                values.forEach(function (key) {
                    if (selectable_keys.indexOf(key) == -1) {
                        out.push(key);
                    }
                });
                out.push(value);
                return out;
            });
        }
    };
}]);


utils.directive('checkSlug', ['$q', '$http', function ($q, $http) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.uniqueA = function (modelValue, viewValue) {
                var userInput = modelValue || viewValue;

                function resolve(response) {
                    delete ngModel.$error.serverError;
                    delete ngModel.$error.slugNotAllowed;
                    delete ngModel.$error.slugInUse;
                    if (response.status == 404) { // ok (slug not found == not used)
                        return $q.resolve();
                    } else if (response.status == 400) { // not allowed
                        ngModel.$error.slugNotAllowed = true;
                    } else if (response.status == 401) { // slug in use
                        ngModel.$error.slugInUse = true;
                    } else { // server errors?
                        ngModel.$error.serverError = true;
                    }
                    return $q.reject();
                }

                return $http.head('/api/page/' + userInput).then(resolve, resolve);
            };
        }
    };
}]);


/**
 * @param text {string}
 * @returns {string}
 */
function slugify(text) {
    return text.toString().toLowerCase().trim()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/&/g, '-and-')         // Replace & with 'and'
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-');        // Replace multiple - with single -
}

utils.service('slugify', [function () {
    return slugify;
}]);

utils.directive('updateOnEnter', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            element.on("keyup", function (ev) {
                ctrl.$commitViewValue();
                scope.$applyAsync(ctrl.$setTouched);
            });
        }
    }
});